<template>
  <div>
    <el-form>
      <el-form-item label="Prestador">
        <find-prestador
          v-if="!roleprestador"
          class="twelve columns"
          :resultado="item.prestador"
          @on-selected="selectPrestador"
        />
        <el-input
          v-else
          v-model="item.prestador.nome"
          :disabled="true"
          @onshow="selectPrestador(item.prestador)"
        />
      </el-form-item>
      <el-form-item
        v-if="roleprofissional || profissionais.length > 0"
        label="Corpo Clínico"
      >
        <el-select

          v-if="!roleprofissional"
          v-model="value.profissional"
          placement="bottom"
          class="twelve columns"
          :filterable="true"
          value-key="idPro"
          placeholder="Selecione o profissional"
          no-data-text="Vazio"
          @change="selectProfissional"
        >
          <el-option
            v-for="e in profissionais"
            :key="e.idPro"
            :label="e.nome"
            :value="e"
          />
        </el-select>
        <el-input
          v-else
          v-model="item.profissional.nome"
          :disabled="true"
        />
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import moment from 'moment';
import { mapActions } from 'pinia';
import { isUndefined, get } from 'lodash';
import { http } from 'apsis-plugin/src';
import { mainStore } from 'operass-spa/src/store/index';
import FindPrestador from './FindPrestador.vue';

export default {
  name: 'EscalaMedica',
  components: { FindPrestador },
  props: {
    item: {
      type: Object,
      required: true,
    },
    roleprestador: {
      type: Boolean,
      required: true,
    },
    roleprofissional: {
      type: Boolean,
      required: true,
    },
  },
  emits: ['update:resultado'],
  data() {
    return {
      prestador: '',
      profissionais: [],
      profissional: '',
      value: this.item.profissional,
      loading: false,
      inicio: moment().format('DDMMYYYY'),
      termino: moment().format('DDMMYYYY'),
      escalas: [],
    };
  },
  watch: {
    item: {
      handler: function load(n) {
        if (!isUndefined(n.prestador) && n.prestador !== this.prestador) {
          this.selectPrestador(n.prestador);
          this.value = n;
        }
      },
      immediate: true,
    },
  },
  created() {
  },
  methods: {
    ...mapActions(mainStore, ['setServiceLoading']),
    selectPrestador(current) {
      if (current.id === undefined || current.id === '') {
        this.item.profissional = {};
        this.item.prestador = {};
        this.value = this.item;
        this.profissionais = [];
        this.loading = false;
        return;
      }
      this.loading = true;
      this.setServiceLoading(true);
      this.comboprofissionaisprestador(current.id).then((value) => {
        this.profissionais = value;
      });

      this.loading = false;
      this.setServiceLoading(false);
    },
    selectProfissional(current) {
      this.item.profissional = current;
      this.setServiceLoading(true);
      this.comboescalamedicaprestador(this.item.prestador.id, this.item.profissional.idPro, this.inicio, this.termino).then((value) => {
        this.escalas = value;
        this.item.escalas = this.escalas;
      });
      this.setServiceLoading(false);
    },
    comboprofissionaisprestador(prestador) {
      return http.get(`/profissionais/web/prestador/${prestador}`).then((response) => get(response, 'data'));
    },
    comboescalamedicaprestador(prestador, profissional, inicio, termino) {
      return http.get(`/prestadores/escala-medica/${prestador}/${profissional}/${inicio}/${termino}`).then((response) => get(response, 'data'));
    },

    onClear() {
      this.$emit('update:resultado', {});
    },
  },
};
</script>
